<template>
  <div>
    <PageAllow controller="PrintTemplates" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="6" md="4">
            <v-cascader
              v-model="selected"
              :label="$t('PrintTemplate.selectTemplate')"
              :hide-details="false"
              :items="templates"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <SearcherDistrict
              v-if="selected == 'order' || selected == 'distribution'"
              v-model="districtSelected"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2" align-self="center">
            <v-select
              v-model="printPage"
              :label="$t('PrintTemplate.pageSize')"
              :items="$t('$print.pageNames')"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" align-self="center">
            <v-row dense>
              <v-spacer />
              <v-btn small class="me-2" v-print="'#printDemo'">
                <v-icon x-small class="pe-1">fa-print</v-icon>
                {{ $t("PrintTemplate.print") }}
              </v-btn>
              <v-btn small color="success" @click.stop="save()">
                <v-icon x-small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.save") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet class="design-opts transparent-background-color">
        <v-row dense class="ma-0">
          <v-spacer />
          <v-expansion-panels
            v-model="panels"
            multiple
            accordion
            :class="panels.length == 0 ? '' : 'design-panels'"
            :style="panels.length == 0 ? 'width: 64px' : ''"
          >
            <v-expansion-panel
              :class="panels.length == 0 ? 'transparent-background-color' : ''"
            >
              <v-expansion-panel-header class="py-0 ps-0">
                <v-tabs
                  v-show="panels.length == 1"
                  fixed-tabs
                  v-model="tab"
                  class="mx-1"
                  background-color="transparent"
                >
                  <v-tab
                    @click.stop="
                      tab = 0;
                      panels == [0] ? null : (panels = [0]);
                    "
                  >
                    {{ $t("PrintTemplate.basicInfo") }}
                  </v-tab>
                  <v-tab
                    @click.stop="
                      tab = 1;
                      panels == [0] ? null : (panels = [0]);
                    "
                  >
                    {{ $t("PrintTemplate.dataSource") }}
                  </v-tab>
                </v-tabs>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="panels.length == 1"
                      v-bind="attrs"
                      v-on="on"
                      text
                      class="pa-0 me-2"
                      :disabled="!print_template"
                      @click.stop="dialog = true"
                    >
                      <v-icon>fa-code</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("PrintTemplate.sourceCode") }}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mx-n6">
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-sheet class="px-1" v-if="print_template">
                      <v-textarea
                        v-model="templateMemo"
                        outlined
                        class="ma-1"
                        hide-details
                        :label="$t('PrintTemplate.memo')"
                      />
                      <span class="caption px-3">
                        {{ $t("PrintTemplate.settings.title") }}
                      </span>
                      <v-divider />
                      <v-checkbox
                        v-model="templateSettings.table_head_repetitive"
                        dense
                        hide-details
                        class="px-2"
                        :true-value="1"
                        :false-value="0"
                        :label="
                          $t('PrintTemplate.settings.tableHeadRepetitive')
                        "
                      />
                      <v-checkbox
                        v-if="templateSettings.table_head_repetitive"
                        v-model="templateSettings.hide_page_counter"
                        dense
                        hide-details
                        class="ps-9 pe-2"
                        :true-value="0"
                        :false-value="1"
                        :label="
                          $t('PrintTemplate.settings.pageCount') +
                          $t('$print.pageText', [1, 'n'])
                        "
                      />
                      <span
                        v-if="templateSettings.table_head_repetitive"
                        class="caption ps-13"
                      >
                        {{ $t("PrintTemplate.settings.pageCountHint") }}
                      </span>
                      <v-checkbox
                        v-model="templateSettings.table_idx"
                        dense
                        hide-details
                        class="px-2"
                        :true-value="1"
                        :false-value="0"
                        :label="$t('PrintTemplate.settings.tableIdx')"
                      />
                      <v-row
                        v-if="
                          print_template &&
                          print_template.id &&
                          print_template.districts_code != null
                        "
                        no-gutters
                        class="pe-2"
                      >
                        <v-spacer />
                        <v-btn outlined dark color="danger" @click.stop="del()">
                          <v-icon x-small class="pe-1">fa-</v-icon>
                          {{ $t("CRUD.delete") }}
                        </v-btn>
                      </v-row>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-expansion-panels
                      v-if="print_template"
                      v-model="dataPanels"
                      accordion
                      flat
                      hover
                      tile
                      popout
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          顶部
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          标题上
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          标题
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          标题
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          表头
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          标题下
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          表格区
                        </v-expansion-panel-header>
                        <v-expansion-panel-content> </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          表尾
                        </v-expansion-panel-header>
                        <v-expansion-panel-content> </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          页尾
                        </v-expansion-panel-header>
                        <v-expansion-panel-content> </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-tab-item>
                </v-tabs-items>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-sheet>

      <div class="design-content">
        <v-sheet
          id="printDemo"
          v-if="print_template"
          class="print-layout-container elevation-2 mb-1"
          :style="
            'width:' + this.printPageOptions[this.printPageSize].width + 'px;'
          "
        >
          <OnePiecePrint
            v-if="
              sampleDatas[selected] &&
              print_template.template &&
              print_template.template.columns
            "
            :formater="print_template.template"
            :data="sampleDatas[selected]"
          />
          <JsonViewer v-else :value="print_template.template" expanded />
        </v-sheet>
      </div>
    </v-sheet>

    <v-dialog v-model="dialog" max-width="1200px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-truncate">
            {{ $t("PrintTemplate.sourceCode") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer">
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('PrintTemplate.sourceCode')"
              rules="json"
            >
              <v-textarea
                v-model="templateJSON"
                outlined
                rows="20"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" @click="saveSourceCode()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
@media (max-width: 799px) {
  .design-content {
    margin-left: 16px;
    margin-right: 16px;
    overflow-x: scroll !important;
  }
  .design-opts {
    margin: 16px;
  }
  .design-panels {
    width: calc(100vw - 32px);
  }
}
@media (min-width: 800px) {
  .design-content {
    margin-left: 24px;
    margin-right: 24px;
    /* margin-right: 356px; */
    overflow-x: scroll !important;
  }
  .design-opts {
    position: absolute;
    right: 24px;
  }
  .design-panels {
    width: 320px;
  }
}
</style>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import VCascader from "@/components/plugins/VCascader";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import PrintTemplates from "@/api/print_templates";
import sampleDistribution from "./sampleDatas/distribution";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import JsonViewer from "vue-json-viewer";
import makeData from "../distributions/makeData";

const defaultTableSettings = {
  table_head_repetitive: 0,
  hide_page_counter: 1,
  table_idx: 1,
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    VCascader,
    SearcherDistrict,
    OnePiecePrint,
    JsonViewer,
    ValidationObserver,
    ValidationProvider,
  },

  data: () => ({
    panels: [0],
    dataPanels: [],
    tab: 0,
    dialog: false,
    selected: null,
    districtSelected: null,
    print_template: null,
    templateMemo: "",
    templateSettings: JSON.parse(JSON.stringify(defaultTableSettings)),
    templateJSON: null,
    templateJSONErrors: [],
    printPage: i18n.t("$print.defaultPageOption"),
    printPageOptions: i18n.t("$print.pageOptions"),
  }),

  watch: {
    selected: {
      handler() {
        this.fetchTemplate();
      },
    },
    districtSelected: {
      handler() {
        this.fetchTemplate();
      },
    },
    printPage: {
      immediate: true,
      handler() {
        this.$store.commit("printPageSize", this.printPage);
        localStorage.setItem("printPageSize", this.printPage);
      },
    },
    print_template: {
      handler() {
        if (this.print_template) {
          this.templateJSON = this.print_template.template
            ? JSON.stringify(this.print_template.template)
            : null;
          this.templateMemo = this.print_template.memo;
          this.templateSettings =
            this.print_template.template &&
            this.print_template.template.settings
              ? this.print_template.template.settings
              : {};
        } else {
          this.templateMemo = null;
          this.templateJSON = null;
          this.templateSettings = JSON.parse(
            JSON.stringify(defaultTableSettings)
          );
        }
      },
    },
    templateSettings: {
      handler() {
        this.print_template.template.settings = this.templateSettings;
      },
    },
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.printSetting"),
        disabled: false,
        href: "/settings/print-templates",
      },
      {
        text: i18n.t("SettingNav.reportDesign"),
        disabled: true,
        href: "/settings/print-templates",
      },
    ],
    templates: () => [
      {
        value: 1,
        text: "订货相关",
        children: [
          {
            value: "order",
            text: "要货单打印", // 完成
            // children: [],
          },
          {
            value: "distribution",
            text: "配送单打印", // 还缺从波次打印配送单
            // children: [],
          },
          // 出库一览的门店配送单合并预打印
          {
            value: "commonShopDistribution",
            text: "门店配送合并预打印",
            // children: [],
          },
          // 配送一览的门店配送合并打印
          {
            value: "shopMergeDistribution",
            text: "门店配送合并打印",
            // children: [],
          },
          {
            value: "orderReturn",
            text: "退货单打印", // 完成
            // children: [],
          },
        ],
      },
      {
        value: 2,
        text: "采购相关",
        children: [
          {
            value: "purchase",
            text: "供应商采购单打印", // 已完成，供应商网页版用的采购单打印格式
            // children: [],
          },
          {
            value: "adminPurchase", // 完成
            text: "采购单打印", // admin管理端采购一览、采购验收用的采购单打印格式
            // children: [],
          },
        ],
      },
      {
        value: 3,
        text: "仓库相关",
        children: [
          {
            value: 31,
            text: "入库相关",
            children: [
              {
                value: "stockOrderIn",
                text: "入库单打印", // 完成
                // children: [],
              },
              {
                value: "purchaseStockOrderIn",
                text: "采购入库单打印", // 完成
                // children: [],
              },
            ],
          },
          {
            value: 32,
            text: "出库相关",
            children: [
              {
                value: "stockOrderOut", //完成
                text: "出库单打印", // 原出库单明细打印
                // children: [],
              },
              {
                value: "shipStockOrderOut",
                text: "发货明细打印", //完成
                // children: [],
              },
              {
                value: "waitOutMaterialCountByShop",
                text: "待出库按门店打印", //完成
                // children: [],
              },
              {
                value: "waitOutMaterialCountByMaterial",
                text: "待出库按商品打印", //完成
                // children: [],
              },
              {
                value: "shopMergeStockOrderOut",
                text: "门店出库合并打印", //完成
                // children: [],
              },
              {
                value: "requisitionMergeStockOrderOut",
                text: "调拨合并打印", //完成
                // children: [],
              },
            ],
          },
          {
            value: 33,
            text: "波次相关",
            children: [
              {
                value: "wavePicking",
                text: "总拣单打印",
                // children: [],
              },
              {
                value: "waveDetail",
                text: "总单打印",
                // children: [],
              },
              {
                value: "waveSorting",
                text: "分拣打印（边拣边分）", // 已完成
                // children: [],
              },
              {
                value: "shopDistribution",
                text: "门店配送打印",
                // children: [],
              },
            ],
          },
        ],
      },
    ],
    sampleDatas() {
      return {
        distribution: makeData.processDetails(sampleDistribution.distribution),
      };
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["printPageSize"]),
  },

  methods: {
    fetchTemplate() {
      if (typeof this.selected == "string")
        PrintTemplates.fetchTemplate(
          {
            print_template_code: this.selected,
            districts_code: this.districtSelected
              ? this.districtSelected.code
              : null,
          },
          true
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.print_template = response.data.print_template;
            } else {
              // 新增打印模板
              this.print_template = {
                print_template_code: this.selected,
                districts_code: this.districtSelected
                  ? this.districtSelected.code
                  : null,
                template: {
                  settings: JSON.parse(JSON.stringify(defaultTableSettings)),
                },
              };
            }
          }.bind(this)
        );
      // else this.print_template = null;
    },
    del() {
      // 删除
      this.$store.dispatch("fullscreenLoading");
      PrintTemplates.del(this.print_template.id)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              // 新增打印模板
              this.print_template = {
                print_template_code: this.selected,
                districts_code: this.districtSelected
                  ? this.districtSelected.code
                  : null,
                template: {
                  settings: JSON.parse(JSON.stringify(defaultTableSettings)),
                },
              };
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    save() {
      //普通保存
      this.$store.dispatch("fullscreenLoading");
      PrintTemplates.save(
        this.print_template.id,
        Object.assign({}, this.print_template, {
          memo: this.templateMemo,
        })
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.print_template = response.data.print_template;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveSourceCode() {
      //源代码模式保存
      this.$refs.observer.validate().then(
        function () {
          PrintTemplates.save(
            this.print_template.id,
            Object.assign({}, this.print_template, {
              template: JSON.parse(this.templateJSON),
            })
          ).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.print_template = response.data.print_template;
                this.dialog = false;
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
  },
};
</script>
